(() => {
  'use strict';

  const root = document.querySelector('[data-mp-document-center]');
  const data = window.MP_PRODUCT_DOCUMENTS;
  if (!root || !data || !Array.isArray(data.products)) return;

  const content = root.querySelector('[data-mp-content]');
  const nav = root.querySelector('[data-mp-category-nav]');
  const navHeading = root.querySelector('[data-mp-nav-heading]');
  const pageTitle = root.querySelector('[data-mp-page-title]');
  const pageIntro = root.querySelector('[data-mp-page-intro]');
  const searchForm = root.querySelector('[data-mp-search-form]');
  const articleMeta = root.querySelector('[data-mp-article-meta]');
  const updatedTime = root.querySelector('[data-mp-updated-time]');
  const breadcrumb = root.querySelector('[data-mp-breadcrumb-current]');
  const search = root.querySelector('[data-mp-search]');
  const clearSearch = root.querySelector('[data-mp-search-clear]');
  const baseDocumentTitle = document.title;
  const productsByHandle = new Map(data.products.map((product) => [product.handle, product]));

  const normalize = (value) => String(value || '')
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/ß/g, 'ss');

  const slug = (value) => normalize(value).replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const relativeTime = new Intl.RelativeTimeFormat('de', { numeric: 'always' });
  const formatRelativeUpdated = (value) => {
    const timestamp = Date.parse(value || data.generatedAt || '');
    if (!Number.isFinite(timestamp)) return 'vor Kurzem';
    const days = Math.max(0, Math.floor((Date.now() - timestamp) / 86_400_000));
    if (days >= 365) return relativeTime.format(-Math.floor(days / 365), 'year');
    if (days >= 30) return relativeTime.format(-Math.floor(days / 30), 'month');
    if (days >= 1) return relativeTime.format(-days, 'day');
    const hours = Math.max(1, Math.floor((Date.now() - timestamp) / 3_600_000));
    return relativeTime.format(-hours, 'hour');
  };
  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };

  const productHref = (handle) => {
    const url = new URL(window.location.href);
    url.search = '';
    url.hash = '';
    url.searchParams.set('produkt', handle);
    return `${url.pathname}${url.search}`;
  };

  const setRoute = (handle, replace = false) => {
    const url = new URL(window.location.href);
    url.searchParams.delete('produkt');
    url.hash = '';
    if (handle) url.searchParams.set('produkt', handle);
    window.history[replace ? 'replaceState' : 'pushState']({}, '', `${url.pathname}${url.search}`);
  };

  const documentCount = (product) => product.documents.length === 1
    ? '1 verifiziertes Dokument'
    : product.documents.length > 1
      ? `${product.documents.length} verifizierte Dokumente`
      : 'Noch keine verifizierten Dokumente';

  const makeProductLink = (product) => {
    const item = element('li');
    const link = element('a', 'mp-docs__product-link');
    link.href = productHref(product.handle);
    link.dataset.mpProductLink = product.handle;
    const copy = element('span');
    copy.append(element('span', 'mp-docs__product-name', product.title));
    copy.append(element('span', 'mp-docs__product-meta', `${product.vendor} · ${documentCount(product)}`));
    link.append(copy);
    item.append(link);
    return item;
  };

  const renderCategoryNav = (activeCategory = '') => {
    navHeading.textContent = 'Alle Abschnitte zu diesem Thema';
    nav.replaceChildren();
    for (const category of data.categories) {
      const link = element('a', '', category.name);
      link.href = `#${slug(category.name)}`;
      if (activeCategory === category.name) link.setAttribute('aria-current', 'true');
      nav.append(link);
    }
  };

  const renderRelatedNav = (product) => {
    navHeading.textContent = 'Beiträge in diesem Abschnitt';
    nav.replaceChildren();
    const related = data.products
      .filter((candidate) => candidate.category === product.category)
      .sort((a, b) => a.title.localeCompare(b.title, 'de'));
    const currentIndex = Math.max(related.findIndex((candidate) => candidate.handle === product.handle), 0);
    const start = Math.max(0, Math.min(currentIndex - 4, related.length - 9));
    for (const candidate of related.slice(start, start + 9)) {
      const link = element('a', '', candidate.title);
      link.href = productHref(candidate.handle);
      link.dataset.mpProductLink = candidate.handle;
      if (candidate.handle === product.handle) link.setAttribute('aria-current', 'true');
      nav.append(link);
    }
    const all = element('a', '', 'Alle Beiträge anzeigen');
    all.href = `#${slug(product.category)}`;
    all.dataset.mpBackCategory = product.category;
    nav.append(all);
  };

  const makeCategory = (category, products, expanded = false) => {
    const section = element('section', 'mp-docs__category');
    section.id = slug(category);
    section.append(element('h2', '', category));
    const list = element('ul', 'mp-docs__product-list');
    const visible = expanded ? products : products.slice(0, 6);
    for (const product of visible) list.append(makeProductLink(product));
    section.append(list);
    if (!expanded && products.length > 6) {
      const button = element('button', 'mp-docs__expand', `Alle ${products.length} Beiträge anzeigen`);
      button.type = 'button';
      button.dataset.mpExpandCategory = category;
      section.append(button);
    }
    return section;
  };

  const renderHome = (query = '') => {
    const term = normalize(query.trim());
    root.dataset.view = 'home';
    pageTitle.textContent = 'Anleitungen und Dokumente – aktuell';
    articleMeta.hidden = true;
    pageIntro.hidden = false;
    searchForm.hidden = false;
    pageIntro.textContent = 'Finde Datenblätter, Bedienungsanleitungen, Installationshinweise, Zertifikate und weitere geprüfte Produktdokumente.';
    breadcrumb.textContent = 'Anleitungen und Dokumente';
    document.title = baseDocumentTitle;
    renderCategoryNav();
    content.replaceChildren();

    if (term) {
      const matches = data.products.filter((product) => normalize(`${product.title} ${product.vendor} ${product.category}`).includes(term));
      content.append(element('h2', 'mp-docs__results-heading', 'Suchergebnisse'));
      content.append(element('p', 'mp-docs__count', `${matches.length} Produkte für „${query.trim()}“`));
      if (!matches.length) {
        const empty = element('section', 'mp-docs__empty');
        empty.append(element('h2', '', 'Kein Produkt gefunden'));
        empty.append(element('p', '', 'Prüfe die Schreibweise oder suche nach Hersteller beziehungsweise Modellnummer.'));
        content.append(empty);
        return;
      }
      const list = element('ul', 'mp-docs__product-list');
      for (const product of matches) list.append(makeProductLink(product));
      content.append(list);
      return;
    }

    for (const category of data.categories) {
      const products = category.products.map((handle) => productsByHandle.get(handle)).filter(Boolean);
      content.append(makeCategory(category.name, products));
    }
  };

  const renderProduct = (product) => {
    root.dataset.view = 'detail';
    search.value = '';
    clearSearch.hidden = true;
    pageTitle.textContent = product.title;
    pageIntro.hidden = true;
    searchForm.hidden = true;
    articleMeta.hidden = false;
    updatedTime.textContent = formatRelativeUpdated(product.updatedAt);
    updatedTime.dateTime = product.updatedAt || data.generatedAt || '';
    breadcrumb.textContent = product.title;
    document.title = `${product.title} – Dokumente | Mini Power`;
    renderRelatedNav(product);
    content.replaceChildren();

    const detail = element('article', 'mp-docs__detail');
    const back = element('button', 'mp-docs__back', '← Alle Anleitungen und Dokumente');
    back.type = 'button';
    back.dataset.mpBack = '';
    detail.append(back);
    detail.append(element('h2', '', 'Verfügbare Dokumente'));
    detail.append(element('p', 'mp-docs__detail-intro', product.documents.length
      ? `Im Folgenden findest du ${documentCount(product)} zu diesem Produkt. Die Links öffnen die jeweilige PDF-Datei in einem neuen Tab.`
      : 'Für dieses aktive Einzelprodukt wurde derzeit noch keine eindeutig passende öffentliche Datei verifiziert. Ähnliche Modelle werden bewusst nicht als Ersatz angezeigt.'));

    if (product.documents.length) {
      const list = element('ul', 'mp-docs__document-list');
      for (const file of product.documents) {
        const item = element('li');
        const link = element('a', 'mp-docs__document-link');
        link.href = file.url;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        const icon = element('span', 'mp-docs__file-icon', 'PDF');
        icon.setAttribute('aria-hidden', 'true');
        const copy = element('span');
        copy.append(element('span', 'mp-docs__document-title', file.title));
        copy.append(element('span', 'mp-docs__document-meta', `${file.type} · ${file.language} · Quelle: ${file.source}`));
        link.append(icon, copy, element('span', 'mp-docs__download', 'PDF öffnen ↗'));
        item.append(link);
        list.append(item);
      }
      detail.append(list);
    } else {
      const empty = element('section', 'mp-docs__empty');
      empty.append(element('h2', '', 'Noch keine verifizierte Datei'));
      empty.append(element('p', '', 'Unser Support prüft neue Herstellerunterlagen fortlaufend. Teile uns gern eine fehlende Datei mit.'));
      detail.append(empty);
    }

    const cta = element('div', 'mp-docs__product-cta');
    const productLink = element('a', '', 'Zum Produkt');
    productLink.href = `/products/${encodeURIComponent(product.handle)}`;
    const supportLink = element('a', 'mp-docs__button mp-docs__button--secondary', 'Fehlendes Dokument melden');
    supportLink.href = '/pages/kontaktaufnahme';
    cta.append(productLink, supportLink);
    detail.append(cta);
    content.append(detail);
    window.scrollTo({ top: root.getBoundingClientRect().top + window.scrollY - 90, behavior: 'smooth' });
  };

  const renderRoute = () => {
    const handle = new URL(window.location.href).searchParams.get('produkt');
    const product = handle ? productsByHandle.get(handle) : null;
    if (handle && !product) setRoute('', true);
    if (product) renderProduct(product);
    else renderHome(search.value);
  };

  root.addEventListener('click', (event) => {
    const productLink = event.target.closest('[data-mp-product-link]');
    if (productLink) {
      event.preventDefault();
      setRoute(productLink.dataset.mpProductLink);
      renderRoute();
      return;
    }

    const expand = event.target.closest('[data-mp-expand-category]');
    if (expand) {
      const category = expand.dataset.mpExpandCategory;
      const products = data.products.filter((product) => product.category === category);
      expand.closest('.mp-docs__category').replaceWith(makeCategory(category, products, true));
      return;
    }

    const back = event.target.closest('[data-mp-back]');
    if (back) {
      setRoute('');
      renderHome();
      window.scrollTo({ top: root.getBoundingClientRect().top + window.scrollY - 90, behavior: 'smooth' });
      return;
    }

    const backCategory = event.target.closest('[data-mp-back-category]');
    if (backCategory) {
      event.preventDefault();
      const category = backCategory.dataset.mpBackCategory;
      setRoute('');
      renderHome();
      requestAnimationFrame(() => document.getElementById(slug(category))?.scrollIntoView({ behavior: 'smooth', block: 'start' }));
    }
  });

  search.addEventListener('input', () => {
    const handle = new URL(window.location.href).searchParams.get('produkt');
    if (handle) setRoute('', true);
    clearSearch.hidden = !search.value;
    renderHome(search.value);
  });

  clearSearch.addEventListener('click', () => {
    search.value = '';
    clearSearch.hidden = true;
    renderHome();
    search.focus();
  });

  searchForm.addEventListener('submit', (event) => event.preventDefault());
  window.addEventListener('popstate', renderRoute);
  renderRoute();
})();
